export async function canPlayAudio() {
    const audioRaw = `data:audio/wav;base64,UklGRjIAAABXQVZFZm10IBIAAAABAAEAQB8AAEAfAAABAAgAAABmYWN0BAAAAAAAAABkYXRhAAAAAA==`;
    return new Audio(audioRaw).play();
}
